import * as React from 'react';

const useCloseOnEscape = ({ close  })=>{
    const closeOnEscKey = React.useCallback((event)=>{
        if (event.key === 'Escape' || event.key === 'Esc') {
            close();
        }
    }, [
        close
    ]);
    React.useEffect(()=>{
        document.addEventListener('keydown', closeOnEscKey, false);
        return ()=>{
            document.removeEventListener('keydown', closeOnEscKey, false);
        };
    }, [
        closeOnEscKey
    ]);
};

export { useCloseOnEscape };
//# sourceMappingURL=use-close-on-escape.js.map
